import { IconPropsType } from '..';

export const StarWithArrowsDownIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.75 17.8167L22.1498 20.15L20.0547 19.0481L17.9597 20.15L18.3595 17.8167L16.6642 16.1638L19.0067 15.8202L20.0547 13.7L21.1028 15.8236L23.4453 16.1673L21.75 17.8167ZM23.8428 19.937V22.095L20.0765 23.6253L20.0547 23.6162L16.2667 22.0961V19.937L20.0547 21.457L23.8428 19.937ZM23.8428 22.6127V24.7696L20.0765 26.3L20.0547 26.2908L16.2667 24.7708V22.6127L20.0547 24.1328L23.8428 22.6127Z"
      fill="#FF944D"
    />
  </svg>
);
